module.exports = __webpack_public_path__ + "static/media/График проведения региональных этапов Конкурса- 2019.xlsx";